import styled from "@emotion/styled";

export const Arrow = styled.div<{ left?: boolean }>(props => ({
    width: 50,
    height: 50,
    position: "absolute",
    textAlign: "center",
    zIndex: 201,
    bottom: "50%",
    userSelect: "none",
    cursor: "pointer",
    marginLeft: props.left ? 17 : undefined,
}));

export const ArrowsContainer = styled.div<{ arrowPosition: "Top" | "Bottom" | "Fixed" }>(props => ({
    position: "absolute",
    width: "100%",
    zIndex: 201,
    bottom: props.arrowPosition === "Bottom" ? 53 : undefined,
    top: props.arrowPosition === "Top" ? 50 : undefined,
}));
